<template>
  <div class="xb-order-return-write">
    <Breadcrumb :breadcrumbData="breadcrumbData"></Breadcrumb>
    <div class="return-write-main">
      <div class="message">
        <div class="left">
          <p>
            <span>退单时间：</span>
            <span>{{ list.time }}</span>
          </p>
          <p>
            <span>退单号：</span>
            <span>{{ list.refundCode }}</span>
          </p>
          <p>
            <span>当前退单状态：</span>
            <span>待退货</span>
          </p>
        </div>
        <div class="right">
          <el-button @click="toOrderDetail(list.orderCode)">关联订单</el-button>
        </div>
      </div>
      <div class="table-img">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="名称">
            <template slot-scope="scope">
              <img class="img" :src="scope.row.img" alt />
              <p class="name">{{scope.row.name}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价" width="208"></el-table-column>
          <el-table-column prop="number" label="数量" width="208"></el-table-column>
          <el-table-column prop="sum" label="小计" width="208"></el-table-column>
        </el-table>
        <div class="table-footer">
          <div class="total">
            <span>订单合计：</span>
            <span class="price">￥{{totalPrice}}</span>
          </div>
          <div class="actual-amount">
            <span>实际退货金额：</span>
            <span class="price">￥{{realRefundMoney}}</span>
          </div>
        </div>
      </div>
      <div class="edit">
        <div class="form">
          <div class="form-left">
            <el-form
              :model="form"
              :rules="rules"
              ref="formRight"
              label-width="95px"
              class="demo-form"
            >
              <div v-if="orderPaymentMethod===4" class="ebank">退款将退回至原银行账户</div>
              <div v-else>
                <el-form-item label="开户人：" prop="accountHolder">
                  <el-input v-model="form.accountHolder" class="gray"></el-input>
                </el-form-item>
                <el-form-item label="开户银行：" prop="bank">
                  <el-input v-model="form.bank" class="gray"></el-input>
                </el-form-item>
                <el-form-item label="银行账号：" prop="bankAccount">
                  <el-input v-model="form.bankAccount" class="gray"></el-input>
                </el-form-item>
              </div>
              <el-form-item label="退货留言：" prop="bemarks">
                <el-input v-model="form.bemarks" class="gray"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-right">
            <el-form
              :model="form"
              ref="formLeft"
              :rules="rules"
              label-width="105px"
              class="demo-form"
            >
              <el-form-item label="退货地址：">
                <span>{{address}}</span>
              </el-form-item>
              <el-form-item label="物流公司：" prop="logisticsCompany">
                <el-select
                  filterable
                  v-model="form.logisticsCompany"
                  placeholder="请选择物流"
                  class="gray"
                  width="200"
                >
                  <el-option
                    v-for="item in logistics"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="运单号：" prop="logisticsNumber">
                <el-input v-model="form.logisticsNumber" class="gray"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="button">
          <el-button class="confirm" @click="saveMessage">确认</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from 'base/xb-base/Breadcrumb';
import XBOrderReturn from 'models/xb/orderReturn.js';
const xbOrderReturn = new XBOrderReturn();
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      breadcrumbData: [
        {
          name: '退货单',
          url: '/personal/personal-menu/xb-order-return'
        },
        {
          name: '填写退货信息',
          url: ''
        }
      ],
      list: {
        refundCode: '',
        time: '',
        orderCode: ''
      },
      tableData: [
        // {
        //   img: 'https://i1.mifile.cn/a1/pms_1550642182.7527088!220x220.jpg',
        //   name: '哈哈哈哈哈哈哈哈哈哈或或或或哈哈哈哈哈哈哈哈哈哈',
        //   price: '￥12.00',
        //   number: 100,
        //   sum: 1200
        // }
      ],
      form: {
        accountHolder: '',
        bank: '',
        bankAccount: '',
        bemarks: '',
        logisticsCompany: '',
        logisticsNumber: ''
      },
      rules: {
        accountHolder: [
          { required: true, message: '请输入开户人', trigger: 'blur' }
        ],
        bank: [{ required: true, message: '请输入开户银行', trigger: 'blur' }],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' }
        ],
        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ]
      },
      orderPaymentMethod: '', // 订单支付方式
      totalPrice: 0, // 退货金额
      realRefundMoney: 0, // 实际退货金额
      address: '', // 退货地址
      logistics: [] // 物流列表
    };
  },
  beforeMount() {
    let refundCode = this.$route.query.refundCode;
    this.list.refundCode = refundCode;
    this.getDetail(refundCode);
    this.getLogistics();
  },
  methods: {
    // 获取退货详情数据进行退货单填写
    getDetail(refundCode) {
      xbOrderReturn.getXBOrderReturnDetail(refundCode).then(res => {
        if (res.success) {
          this.list.time = this.fmtDate(res.result.refundOrder.createTime);
          this.list.orderCode = res.result.refundOrder.orderCode;
          let arr = [];
          res.result.refundDetailList.map((value, index, array) => {
            let obj = {};
            obj.id = value.goodsId;
            obj.img = value.goodsPic;
            obj.name = value.goodsName;
            obj.price = value.goodsUnitPrice;
            obj.number = value.quantity;
            obj.sum = value.subtotal;
            arr.push(obj);
          });
          this.tableData = arr;
          this.orderPaymentMethod = res.result.refundOrder.orderPaymentMethod;
          this.address = res.result.refundAddress.totalAddress;
          this.totalPrice = res.result.refundOrder.totalPrice;
          this.realRefundMoney = res.result.refundOrder.realRefundMoney;
        }
      });
    },
    // 获取物流数据
    getLogistics() {
      xbOrderReturn.getXBLogistics().then(res => {
        res.result.map(value => {
          let obj = {};
          obj.value = value.id;
          obj.label = value.expressName;
          this.logistics.push(obj);
        });
      });
    },
    // 点击保存
    saveMessage() {
      this.$refs['formRight'].validate(valid => {
        if (valid) {
          this.$refs['formLeft'].validate(valid => {
            if (valid) {
              let refundCode = this.list.refundCode;
              let bankUser = this.form.accountHolder;
              let bankName = this.form.bank;
              let bankAccount = this.form.bankAccount;
              let message = this.form.bemarks;
              // let totalAddress = this.address;
              let expressId = this.form.logisticsCompany;
              let expressCode = this.form.logisticsNumber;
              let data = {
                refundCode,
                bankUser,
                bankName,
                bankAccount,
                message,
                expressId,
                expressCode
              };
              xbOrderReturn.postXBSubmitInfo(data).then(res => {
                if (res.success) {
                  this.$message.success('提交成功');
                  this.$router.push('/personal/personal-menu/xb-order-return');
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关联订单
    toOrderDetail(orderCode) {
      this.$router.push({
        path: '/personal/xb-order-detail',
        query: {
          orderCode
        }
      });
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? '0' + dateFn.getHours()
          : '' + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? '0' + dateFn.getMinutes()
          : '' + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? '0' + dateFn.getSeconds()
          : '' + dateFn.getSeconds();
      let time = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + xx + ':' + ss;
      return time;
    }
  }
};
</script>
<style lang='scss' scoped>
.xb-order-return-write {
  color: #606266;
  .return-write-main {
    padding: 20px;
    background: #fff;
    min-height: 600px;
    .message {
      display: flex;
      height: 32px;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 20px;
      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          margin-right: 100px;
        }
      }
      .right {
        .el-button {
          width: 120px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(223, 52, 69, 1);
          background: #fff;
          font-size: 16px;
          color: rgba(223, 52, 69, 1);
        }
      }
    }
    .table-img {
      margin-bottom: 24px;
      .table-footer {
        height: 32px;
        box-sizing: border-box;
        border: 1px solid #f2f6fc;
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        .total {
          width: 208px;
          .price {
            font-size: 16px;
          }
        }
        .actual-amount {
          width: 248px;
          .price {
            font-size: 16px;
            color: #df3445;
          }
        }
      }
    }
    .edit {
      padding-bottom: 150px;
      position: relative;
      .form {
        display: flex;
        justify-content: space-between;
        .form-left {
          width: 560px;
          height: 228px;
          border: 1px solid #e4e4e4;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 20px 145px 0 0;
          .ebank {
            height: 105px;
            padding-left: 20px;
            line-height: 105px;
          }
        }
        .form-right {
          width: 560px;
          height: 228px;
          border: 1px solid #e4e4e4;
          box-sizing: border-box;
          padding: 20px 135px 0 0;
          border-radius: 2px;
        }
      }
      .button {
        width: 100%;
        height: 32px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        .confirm {
          width: 60px;
          height: 32px;
          background: rgba(223, 52, 69, 1);
          border-radius: 4px;
          padding: 0;
          letter-spacing: 2px;
          border: 1px solid rgba(223, 52, 69, 1);
          color: #fff;
        }
        .cancel {
          width: 120px;
          height: 32px;
          background: #fff;
          border-radius: 4px;
          padding: 0;
          letter-spacing: 2px;
          color: rgba(223, 52, 69, 1);
          border: 1px solid rgba(223, 52, 69, 1);
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.xb-order-return-write {
  .el-form {
    .el-form-item {
      margin-bottom: 20px;
      .el-form-item__label {
        padding-right: 5px;
      }
      .el-select {
        width: 318px;
      }
    }
  }
}
</style>
